<template>
  <SelectSingleInput
    v-model="model"
    :items="items"
    item-text="reasonDtlText"
    item-value="reasonDtlCd"
    :label="label"
    :disabled="disabledComputed"
    :loading="loading"
    :required="requiredComputed"
  />
</template>

<script>
import SelectSingleInput from '@/components/atoms/base/select/SelectSingleInput'
import { API } from '@/plugins/api'
import APIUtils from '@/mixin/api-utils.js'
import Message from '@/mixin/message-utils.js'

export default {
  name: 'MmmmReasonDtlInput',

  mixins: [APIUtils, Message],

  components: { SelectSingleInput },

  props: {
    value: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: false,
      default: function () {
        return this.$t('ELE0447')
      },
    },
    disabled: {
      type: Boolean,
      default: false,
      required: false,
    },
    required: {
      type: Boolean,
      default: false,
      required: false,
    },
    validOnly: {
      type: Boolean,
      required: false,
      default: false,
    },
    reasonCd: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      items: [],
      loading: false,
    }
  },

  watch: {
    value: {
      handler(changedValue) {
        this.onChange(changedValue)
      },
    },
    reasonCd: {
      async handler() {
        await this.setReason()
      },
      immediate: true,
    },
  },

  computed: {
    model: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value ? value : '')
      },
    },
    requiredComputed() {
      let required = this.required
      if (this.items.length == 0) {
        required = false
      }
      return required
    },
    disabledComputed() {
      let disabled = this.disabled
      if (this.items.length == 0) {
        disabled = true
      }
      return disabled
    },
  },

  methods: {
    onChange(value) {
      this.$emit('change', value)
    },

    async setReason() {
      this.loading = true
      try {
        this.items = []
        if (this.reasonCd) {
          let params = {
            reasonCd: this.reasonCd,
            validOnly: this.validOnly,
          }

          const elements = await API.get('/master/mmmm/reasonDtls', params)
          elements.forEach((element) => {
            element['reasonDtlText'] = element['reasonDtlName']
            this.items.push(element)
          })
        }
      } catch (error) {
        this.items = []
        this.setErrorMessage(this.resolveErrorMessage(error, this.$t('MSG0002', { p0: this.$t('ELE0447') })))
      } finally {
        this.loading = false
      }
    },
  },
}
</script>
